


































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import editMultiLanguage from "./editMultiLanguage.vue";
const attr = namespace("attribute");
const commonVuex = namespace("common");

let keyId: number = 0;
@Component({ components: { editMultiLanguage } })
export default class add extends Vue {
  dialogVisible: boolean = false;
  radio: string = "";
  loading: boolean = false;
  // RequireOptions: any = RequireOptions;
  // AttrOptions: any = AttrOptions;
  // ValueTypeOptions: any = ValueTypeOptions;
  attrValueList: any = [];
  deleteAttrValueList: any = [];
  ruleForm: any = {
    attrCode: "",
    attrName: "",
    attrType: null,
    attrValueType: null,
    attrImage: "",
    attrIsRequired: 0,
    attrIsChannel: null,
    attrIsLanguage: 0,
    attrIsFrontDisplay: 1,
    attrIsFrontFilterable: 0,
    used4gensku: 1,
    attrValueList: [
      {
        attrValueName: ""
        // attrValueLocales: []
      }
    ],
    isMultiOtionList: [
      {
        attrValueName: "",
        attrValueLocales: []
      }
    ],
    noMutiOtionList: [
      {
        attrValueName: ""
      }
    ]
  };
  skuRuleForm: any = {
    attrIsRequired: 1,
    attrIsFrontDisplay: 1,
    attrIsFrontFilterable: 1
  };
  originPerLocale = 0;
  get AttrOptions() {
    return [
      {
        label: this.$t("Attribute.product"),
        value: 1
      },
      {
        label: "SKU",
        value: 2
      }
      // {
      //   label: "Category",
      //   value: 3
      // },
      // {
      //   label: "Brand",
      //   value: 4
      // }
    ];
  }
  get ValueTypeOptions() {
    return [
      {
        label: this.$t("Attribute.Single_Select"),
        value: 0
      },

      {
        label: this.$t("Attribute.Multiple_Select"),
        value: 1
      },
      {
        label: this.$t("Attribute.Number"),
        value: 3
      },
      {
        label: this.$t("Attribute.Text"),
        value: 2
      },
      {
        label: this.$t("Attribute.Text_Area"),
        value: 4
      }
    ];
  }
  get RequireOptions() {
    return [
      {
        label: this.$t("Basic.yes"),
        value: 1
      },
      {
        label: this.$t("Basic.no"),
        value: 0
      }
    ];
  }
  get rules() {
    return {
      attrCode: [
        {
          required: true,
          message: this.$t("Basic.required_msg")
        }
      ],
      attrName: [
        {
          required: true,
          message: this.$t("Basic.required_msg")
        },
        {
          max: 20,
          message: this.$t("Basic.required_20_char")
        }
      ],
      attrType: [
        {
          required: true,
          message: this.$t("Basic.required_msg")
        }
      ],
      attrValueType: [
        {
          required: true,
          message: this.$t("Basic.required_msg")
        }
      ],
      used4gensku: [
        {
          required: true,
          message: this.$t("Basic.required_msg")
        }
      ],
      attrIsRequired: [
        {
          required: true,
          message: this.$t("Basic.required_msg")
        }
      ],
      attrIsChannel: [
        {
          required: true,
          message: this.$t("Basic.required_msg")
        }
      ],
      attrIsLanguage: [
        {
          required: true,
          message: this.$t("Basic.required_msg")
        }
      ],
      attrIsFrontFilterable: [
        {
          required: true,
          message: this.$t("Basic.required_msg")
        }
      ],
      attrIsFrontDisplay: [
        {
          required: true,
          message: this.$t("Basic.required_msg")
        }
      ],
      option: [
        { required: true, type: "array", validator: this.optionValidate }
      ]
    };
  }
  get notIdentifySku() {
    return !(this.ruleForm.attrType === 2 && this.ruleForm.used4gensku === 1);
  }
  @attr.State editData;
  @commonVuex.State languageList;
  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;
  @Watch("editData")
  onEditDataChange(val, oldVal) {
    if (this.isEdit) {
      this.originPerLocale = val.attrIsLanguage;
      if (val.attrValueList) {
        val.attrValueList.forEach(item => {
          if (!item.attrValueLocales) {
            this.$set(item, "attrValueLocales", []);
          }
        });
      }
      this.ruleForm = {
        ...this.ruleForm,
        ...val
      };
      if (val.attrValueList) {
        if (val.attrIsLanguage) {
          this.ruleForm.isMultiOtionList = [...val.attrValueList];
        } else {
          this.ruleForm.noMutiOtionList = [...val.attrValueList];
        }
      }
      this.attrValueList =
        JSON.parse(JSON.stringify(this.ruleForm.attrValueList)) || [];
      this.deleteAttrValueList = [];
    }
  }
  @Watch("dialogVisible")
  watchDialogVisible(val) {
    let $form: any = this.$refs.form;
    if (val) {
      if (!this.isEdit) {
        this.ruleForm.isMultiOtionList = [
          {
            attrValueName: "",
            attrValueLocales: []
          }
        ];
        this.ruleForm.noMutiOtionList = [
          {
            attrValueName: ""
          }
        ];
      }
      $form && $form.clearValidate();
    } else {
      $form && $form.resetFields();
    }
  }
  @Watch("ruleForm.attrIsFrontDisplay")
  watchDisplay(val) {
    if (!val) {
      this.ruleForm.attrIsFrontFilterable = 0;
    }
  }
  @attr.State PageInput;
  @attr.Action createAttr;
  @attr.Action getAttr;
  @attr.Action updateAttr;
  @attr.Mutation setPageInput;
  created() {
    // this.rules = rules.apply(this);
  }
  handleSubmit() {
    const $form: any = this.$refs["form"];
    $form.validate(valid => {
      if (valid) {
        this.handleConfirm();
      }
    });
  }
  async handleConfirm() {
    let { attrValueList, isMultiOtionList, noMutiOtionList } = this.ruleForm;
    let finalValueOtion = this.ruleForm.attrIsLanguage
      ? isMultiOtionList
      : noMutiOtionList;
    let arr = [...finalValueOtion, ...this.deleteAttrValueList];
    const attrValueListFilter = arr.map(
      (
        { attrValueCode, attrValueName, logicDelete = 0, attrValueLocales },
        index
      ) => {
        let result = {};
        if (this.isEdit) {
          result = { attrValueCode, attrValueName, logicDelete, sort: index };
        } else {
          result = { attrValueName, sort: index };
        }
        if (this.ruleForm.attrIsLanguage) {
          attrValueLocales;
          result = {
            ...result,
            attrValueLocales
          };
        }
        return result;
      }
    );
    let pramas = {
      ...this.ruleForm,
      attrValueList: [0, 1].includes(this.ruleForm.attrValueType)
        ? attrValueListFilter
        : []
    };
    if (!this.notIdentifySku) {
      pramas = {
        ...pramas,
        ...this.skuRuleForm
      };
    }
    delete pramas.isMultiOtionList;
    delete pramas.noMutiOtionList;
    if (this.isEdit) {
      await this.update(pramas);
    } else {
      await this.create(pramas);
    }
  }
  handleAddOptions() {
    keyId = keyId + 1;
    let list = this.ruleForm.attrIsLanguage
      ? this.ruleForm.isMultiOtionList
      : this.ruleForm.noMutiOtionList;
    list.push({
      attrValueName: "",
      attrValueLocales: []
    });
  }
  handleDelOptions(index, code) {
    let list = this.ruleForm.attrIsLanguage
      ? this.ruleForm.isMultiOtionList
      : this.ruleForm.noMutiOtionList;
    list.splice(index, 1);
    if (code) {
      let item = this.attrValueList.find(item => item.attrValueCode === code);
      item.logicDelete = 1;
      this.deleteAttrValueList.push(item);
    }
  }
  async create(data) {
    this.loading = true;
    try {
      await this.createAttr(data);
      this.loading = false;
      let msg: any = this.$t("Basic.success");
      this["$message"].success(msg);
      this.setPageInput({ ...this.PageInput, pageNum: 1 });
      const $form: any = this.$refs.form;
      $form.resetFields();
      this.ruleForm.attrImage = "";
      this.ruleForm = { ...this.ruleForm };
      this.dialogVisible = false;
      this.getAttr();
    } catch {
      this.loading = false;
    }
  }
  async update(data) {
    await this.updateAttr(data);
    this.dialogVisible = false;
    this.loading = false;
    this.getAttr();
  }
  onsuccess(url) {
    this.ruleForm.attrImage = url;
    this.ruleForm = { ...this.ruleForm };
  }
  onRemove(index, fileList) {
    this.ruleForm.attrImage = "";
    this.ruleForm = { ...this.ruleForm };
  }
  curEditOption: any = "";
  curEditIndex = 0;
  // 编辑option的多语言
  editMultiOption(item, index) {
    this.curEditOption = item;
    this.curEditIndex = index;
    const $edit: any = this.$refs.multiOptionDialog;
    $edit.dialogVisible = true;
  }
  saveMultiOption(data) {
    this.curEditOption.attrValueLocales = data;
    const $edit: any = this.$refs.form;
    let index = $edit.validateField(
      "attrValueList." + this.curEditIndex + ".attrValueLocales"
    );
  }

  optionValidate(rule, value, callback) {
    let all = this.isAllMultiLang(value);
    if (!value || !all) {
      callback(new Error());
    }
    callback();
  }
  isAllMultiLang(value) {
    return this.languageList.every(_ => {
      let arr = value.filter(attr => attr.locale === _.value);
      return arr.length > 0;
    });
  }
  // changePerLocale(val) {
  //   if (val) {
  //     this.ruleForm.attrValueList = val
  //       ? this.isMultiOtionList
  //       : this.noMutiOtionList;
  //   }
  // }
  changAttrType() {
    if (this.ruleForm.attrType === 2) {
      this.ruleForm.attrValueType = 0;
    }
  }

  handleMoveUp(list, index) {
    this.moveFn(list, index, index - 1);
  }
  handleMoveDwon(list, index) {
    this.moveFn(list, index, index + 1);
  }

  // 交换数组两个元素
  moveFn(block: any[], index1, index2) {
    block[index1] = block.splice(index2, 1, block[index1])[0];
  }
}
